import { useMemo } from 'react';
import { StepsType } from 'core/stepper/Stepper.types';
import { useGetSteps } from 'components/Stepper/useGetSteps';
import TypeOfOrder from 'widgets/CaseManagement/TypeOfOrder/TypeOfOrder';
import ReasonForSale from 'widgets/CaseManagement/ReasonForSale/ReasonForSale';
import useTypeOfOrder from 'datasource/CaseManagement/useTypeOfOrder';
import useReasonForSale from 'datasource/CaseManagement/useReasonForSale';
import BankInformation from 'widgets/CaseManagement/BankInformation';
import useBankInformation from 'datasource/CaseManagement/useBankInformation';
import Summary from 'widgets/CaseManagement/Summary';
import useSummary from 'datasource/CaseManagement/useSummary';
import { useCreateCaseState } from 'datasource/CaseManagement/CreateCaseManager';

export const stepsKeys = {
    TypeOfOrder: 'type-of-order',
    ReasonForSale: 'reason-for-sale',
    BankInformation: 'bank-information',
    Summary: 'summary',
};

export const process = {
    main: 'parent',
    // summary: 'summary',
    // bankDetails: 'bankDetails',
};

const useCreateNewCaseFlow = () => {
    const { isPaymentOrderPrivateAccount } = useCreateCaseState();

    const createNewCaseFlow: StepsType = useMemo(() => ({
        [stepsKeys.TypeOfOrder]: {
            datasource: useTypeOfOrder,
            process: process.main,
            stepperTitle: 'createNewCase.TypeOfOrder.Stepper.title',
            contentTitle: 'createNewCase.TypeOfOrder.Content.title',
            contentClassName: 'create-new-case type-of-order',
            component: TypeOfOrder,
            url: 'type-of-order',
            next: [
                {
                    target: stepsKeys.BankInformation,
                    condition: () => isPaymentOrderPrivateAccount,
                },
                {
                    target: stepsKeys.ReasonForSale,
                    condition: () => !isPaymentOrderPrivateAccount,
                },
            ],
            isBegin: true,
        },
        [stepsKeys.ReasonForSale]: {
            datasource: useReasonForSale,
            process: process.main,
            stepperTitle: 'createNewCase.ReasonForSale.Stepper.title',
            contentTitle: 'createNewCase.ReasonForSale.Content.title',
            contentClassName: 'create-new-case reason-for-sale',
            component: ReasonForSale,
            url: 'reason-for-sale',
            prev: [
                {
                    target: stepsKeys.TypeOfOrder,
                    condition: () => true,
                },
            ],
            next: [
                {
                    target: stepsKeys.BankInformation,
                    condition: () => true,
                },
            ],
        },
        [stepsKeys.BankInformation]: {
            datasource: useBankInformation,
            process: process.main,
            stepperTitle: 'createNewCase.BankInformation.Stepper.title',
            contentTitle: 'createNewCase.BankInformation.Content.title',
            contentClassName: 'create-new-case bank-information',
            component: BankInformation,
            url: 'bank-information',
            prev: [
                {
                    target: stepsKeys.ReasonForSale,
                    condition: () => !isPaymentOrderPrivateAccount,
                },
                {
                    target: stepsKeys.TypeOfOrder,
                    condition: () => isPaymentOrderPrivateAccount,
                },
            ],
            next: [
                {
                    target: stepsKeys.Summary,
                    condition: () => true,
                },
            ],
        },
        [stepsKeys.Summary]: {
            datasource: useSummary,
            process: process.main,
            stepperTitle: 'createNewCase.Summary.Stepper.title',
            contentTitle: 'createNewCase.Summary.Stepper.title',
            contentClassName: 'create-new-case summary',
            component: Summary,
            url: 'summary',
            prev: [
                {
                    target: stepsKeys.BankInformation,
                    condition: () => true,
                },
            ],
            isEnd: true,
        },
    }), [isPaymentOrderPrivateAccount]);

    const { stepsBasedOnState } = useGetSteps({ flow: createNewCaseFlow, initialStep: stepsKeys.TypeOfOrder });

    return { stepsBasedOnState };
};

export default useCreateNewCaseFlow;
